module.exports = __webpack_public_path__ + "static/media/03-3-reception.8b758e7a.webp";